import React from 'react';

import {
  pickSelectStyle
} from 'configs/components/select';
import {
  months
} from 'configs/constants/reports';
import * as fns from 'date-fns';
import {
  translateSelectItem,
  translateAllSelectItems,
} from 'helperFunctions';
import {
  FormGroup,
  Label,
  Button
} from 'reactstrap';
import Select from 'react-select';

import DatePicker from 'components/DatePicker';
import {
  useTranslation
} from "react-i18next";

var years = [];
for ( let i = new Date().getFullYear(); i >= 2000; i-- ) {
  years.push( {
    value: i,
    label: i
  } );
}

export default function MonthSelector( props ) {
  const {
    blockedShow,
    showFreeDateSelect,
    fromDate,
    onChangeFromDate,
    toDate,
    onChangeToDate,
    onTrigger,
  } = props;

  const {
    t
  } = useTranslation();

  const [ year, setYear ] = React.useState( {
    label: new Date().getFullYear(),
    value: new Date().getFullYear()
  } );
  const [ month, setMonth ] = React.useState( translateSelectItem(
    months[ new Date().getMonth() ], t
  ) );

  return (
    <div>
        <FormGroup>
          <Label>{t('selectMonthAndYear')}</Label>
          <div className="flex-row">
            <div className="width-50-p p-r-20">
              <Select
                value={month}
                onChange={setMonth}
                options={translateAllSelectItems(months,t)}
                styles={pickSelectStyle()}
                />
            </div>
            <div className="width-50-p p-r-20">
              <Select
                value={year}
                onChange={setYear}
                options={years}
                styles={pickSelectStyle()}
                />
            </div>
            <Button
              type="button"
              disabled={
                year===null ||
                month===null ||
                blockedShow
              }
              className="btn-primary max-width-150"
              onClick={() => {
                let firstDay = fns.startOfMonth( new Date( year.value, month.value-1 ) );
                let lastDay = fns.endOfMonth( new Date( year.value, month.value-1 ) );
                onChangeFromDate(firstDay);
                onChangeToDate(lastDay);
                onTrigger(firstDay, lastDay);
              }}
              >
              {t('show')}
            </Button>
          </div>
        </FormGroup>
        { showFreeDateSelect &&
          <FormGroup>
            <Label>{t('selectPrefferedDateRange')}</Label>
            <div className="flex-row">
              <div className="flex flex-input p-r-20">
                <DatePicker
                  hideTime
                  placeholderText={t('from')}
                  className="form-control"
                  selected={fromDate}
                  onChange={date => onChangeFromDate(date) }
                  />
              </div>
              <div className="flex flex-input p-r-20">
                <DatePicker
                  hideTime
                  placeholderText={t('to')}
                  className="form-control"
                  selected={toDate}
                  onChange={date => onChangeToDate(date)}
                  />
              </div>
              <Button
                type="button"
                className="btn-primary max-width-150"
                disabled={
                  blockedShow ||
                  ( fromDate !== null &&
                    toDate !== null &&
                    ( fromDate.valueOf() > toDate.valueOf() )
                  )
                }
                onClick={() => onTrigger(fromDate, toDate)}
                >
                {t('show')}
              </Button>
            </div>
          </FormGroup>
        }
      </div>
  );
}
